<template>
  <div>
    <v-container grid-list-xl class="word-wrap mt-5">
      <add-advert :categoryItems="categoryItemsNews" @addNewItem="(item)=>addNewItem(item)" />
      <v-layout row wrap justify-center mt-5>
        <v-row>
          <v-col cols="2" sm="12" md="2"></v-col>
          <v-col cols="8" sm="12" md="8">
            <v-list
              subheader
              two-line
              style="background-color: transparent !important"
            >
              <v-layout
                class="mx-4 mb-4"
                align-center
                v-if="!$store.state.pageLoadingStatus"
              >
                <h3 class="font-weight-bold defaultColor--text">
                  {{ $t("title.adverts") }}
                </h3>
                <v-spacer />
                <v-select
                  v-model="selectedCategory"
                  :items="categoryItems"
                  color="defaultColor"
                  @change="changeCategory()"
                  small
                  hide-details
                  class="mb-3"
                  style="width: 30px"
                  item-text="text"
                  outlined
                  rounded
                  dense
                  item-value="value"
                  :label="$t('labels.selectCategory')"
                  persistent-hint
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t("description.noContent") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-layout>
              <div
                v-for="(item, index) in data"
                :key="item.Id.concat(index.toString())"
              >
                <advert-list-item
                  :item="item"
                  :buttonVisible="true"
                  buttonText="İlan Detayı"
                  :buttonDisabled="false"
                />
              </div>
              <loading-progress :status="loadMoreLoading" />
            </v-list>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ContentService from "@/services/ContentService";
import CategoryService from "@/services/CategoryService";
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import AdvertListItem from "../../components/Adverts/AdvertListItem.vue";
import AddAdvert from "../../components/Adverts/AddAdvert.vue";
export default {
  data: () => {
    return {
      page: 1,
      pageSize: 15,
      data: [],
      noData: false,
      loadMoreLoading: false,
      paginationStop: false,
      selectedCategory: "",
      searchText: "",
      categoryItems: [],
      categoryItemsNews: [],
    };
  },
  components: {
    LoadingProgress,
    AdvertListItem,
    AddAdvert,
  },
  methods: {
    getContent() {
      this.page == 1 ? setPageLoading(true) : (this.loadMoreLoading = true);
      let flag = this.selectedCategory === "" ? false : true;
      ContentService.getContent(
        "ilanlar",
        this.page,
        this.pageSize,
        flag,
        this.searchText,
        this.selectedCategory
      )
        .then((res) => {
          if (res.data.length == 0) this.paginationStop = true;
          if (this.page != 1) {
            this.data = [...this.data, ...res.data];
          } else {
            this.data = res.data;
          }
          if (res.data.length <= 0) {
            this.noData = true;
            //this.paginationStop = true;
            //this.data = [];
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.page == 1
            ? setPageLoading(false)
            : (this.loadMoreLoading = false);
        });
    },

    getCategoris() {
      this.categoryItemsNews = []
      this.categoryItems = [{ text: "Tümü", value: "" }];
      setPageLoading(true);
      CategoryService.getCategoriesWithParent("Adverts")
        .then((res) => {
          res.data.forEach((element) => {
            let langText = element.Translation.filter(
              (x) => x.Culture === "tr"
            );
            let text = langText[0].Name;
            let obj = { text, value: element.Id };
            this.categoryItems.push(obj);
            this.categoryItemsNews.push(obj)
          });
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          setPageLoading(false);
        });
    },

    changeCategory() {
      this.page = 1;
      this.data = [];
      this.getContent();
    },

    //Infinite scroll
    scrollTop(e) {
      //Yeni doğanlar servisinde pagination yapısı olmadığı için sistem kapatıldı
      if (!this.loadMoreLoading && !this.$store.state.pageLoadingStatus) {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100
        ) {
          if (!this.paginationStop) this.paginationPage();
        }
      }
    },

    paginationPage() {
      this.page++;
      this.getContent();
    },

    addNewItem(item){
      this.data.unshift(item)
    },
  },
  computed: {
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    this.getCategoris();
    this.getContent();
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {},
};
</script>

<style></style>
